module.exports = __webpack_public_path__ + "7e0091e9e1fbc52b0c5e680af401f721.pdf";